import React from 'react'
import Radio, { RadioCircle } from '../../styles/radio'

export default ({ name, label, onChange, value }) => {
  const onValueChange = e => onChange(e.target.checked === value)
  return (
    <Radio>
      {label}
      <input type="radio" onChange={onValueChange} name={name} id={name} />
      <RadioCircle />
    </Radio>
  )
}